import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from 'app/shared/common/base-component';


@Component({
  selector: 'detect-brow',
  templateUrl: './detect-browser.component.html',
  styleUrls: ['./detect-browser.component.scss']
})
export class DetectBrowser  extends BaseComponent implements OnInit  {

  errMessageVisible: boolean = false;
  errMessage: string = "";
  
  constructor(
    protected router: Router,
    private activeRoute: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit() {

  }

}
